module.exports = __webpack_public_path__ + "static/media/mudey_rating2.45aba8d3.svg";